import React from 'react';
import { X, Check } from 'lucide-react';

const before = [
  'Chasing cold leads manually between client work',
  'Hiring and firing junior SDRs every 6 months',
  'Messages landing in spam, or worse, getting you flagged',
  'Lists of "prospects" who left the company 18 months ago',
  'Best-guess follow-ups with zero attribution',
  "Pipeline you can't forecast or scale",
];

const after = [
  'Qualified meetings appear on your calendar on autopilot',
  'One senior team running the entire machine for you',
  '99%+ inbox placement across warmed, isolated domains',
  'Real-time verified data, refreshed every single week',
  'Daily-tuned campaigns with live reply-rate reporting',
  'Predictable, forecastable pipeline math every month',
];

const stats = [
  { v: '312+', l: 'Qualified meetings booked' },
  { v: '$4.8M+', l: 'opportunities generated worth' },
  { v: '20+', l: 'Active pipelines running' },
  { v: '97%', l: 'Client retention rate' },
];

export default function BeforeAfter() {
  return (
    <section id="results">
      <div className="container-x">
        <div className="section-intro">
          <span className="eyebrow reveal">Before vs. After</span>
          <h2 className="section-heading reveal reveal-delay-1" style={{ marginTop: 24 }}>
            What changes once JustICP <span className="text-gradient">runs your pipeline.</span>
          </h2>
          <p className="reveal reveal-delay-2">Same 30 days. Wildly different experience. This is what your outbound looks like before and after we take it over.</p>
        </div>
        <div className="ba-grid">
          <div className="ba-card ba-before reveal">
            <span className="ba-tag bad">Before</span>
            <h3 className="ba-title">Doing it yourself</h3>
            <ul className="ba-list bad">
              {before.map((b, i) => <li key={i}><X size={16} style={{ color: 'rgba(255,255,255,0.3)' }}/>{b}</li>)}
            </ul>
          </div>
          <div className="ba-card ba-after reveal reveal-delay-2">
            <span className="ba-tag good">After JustICP</span>
            <h3 className="ba-title">With our system running</h3>
            <ul className="ba-list good">
              {after.map((b, i) => <li key={i}><Check size={16} style={{ color: 'var(--primary)' }}/>{b}</li>)}
            </ul>
          </div>
        </div>
        <div className="ba-stats">
          {stats.map((s, i) => (
            <div key={i} className="ba-stat reveal" style={{ transitionDelay: `${i * 0.08}s` }}>
              <div className="v">{s.v}</div>
              <div className="l">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
